import React, { memo } from 'react';
import styled from 'styled-components';
import { spacing } from '@chegg-ui/theme';
var PxCaptchaContainer = styled.div.withConfig({
  componentId: "sc-qyq7cv-0"
})(["display:grid;justify-items:center;margin-top:", ";> iframe{margin:0 auto;}"], spacing.px16);
var PxCaptcha = function PxCaptcha(_ref) {
  var dataTest = _ref.dataTest;
  return /*#__PURE__*/React.createElement(PxCaptchaContainer, {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("div", {
    id: "px-captcha"
  }));
};
export default /*#__PURE__*/memo(PxCaptcha);